import { makeStyles } from '@fluentui/react-components';

export const useFluentErrorViewStyles = makeStyles({
  emptyStateContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    position: 'absolute',
    height: '100%',
    width: '100%',
  },
});
